import React from 'react';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router';
import moment from 'moment';
import {
  Row,
  Col,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
} from '@sketchpixy/rubix';

import {routeUrl} from '../routeUrl';

@withRouter
class AdminUserTable extends React.Component {
  componentDidMount() {
    $(ReactDOM.findDOMNode(this.adminUserDataTables)).dataTable({
      responsive: true,
      columnDefs: [
        {targets: [-1, -3], className: 'dt-body-right'},
      ],
    });
  }

  render() {
    return (
        <Table ref={(c) => this.adminUserDataTables = c} className="display nowrap" cellSpacing="0" width="100%">
          <thead>
          <tr>
            <th>Email</th>
            <th>User name</th>
            <th>Role Group</th>
            <th>Joined</th>
            <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
          </thead>
          <tfoot>
          <tr>
            <th>Email</th>
            <th>User name</th>
            <th>Role Group</th>
            <th>Joined</th>
            <th />
          </tr>
          </tfoot>
          <tbody>
          {
            this.props.data.map(admin => {
              let roleName = admin.roleGroupName.length > 0 ? admin.roleGroupName[0] : null;
              return (
                  <tr key={admin.adminUserEmail}>
                    <td>{admin.adminUserEmail}</td>
                    <td>{admin.adminUserName}</td>
                    <td>&nbsp;&nbsp;{roleName}&nbsp;&nbsp;</td>
                    <td>{moment(admin.createdTime).format('llll')}</td>
                    <td>
                      <Link to={`${routeUrl.adminUserEdit}/${admin.adminUserId}`}>
                        <Icon bundle="fontello" glyph="pencil" />
                      </Link>
                    </td>
                  </tr>
              );
            })
          }
          </tbody>
        </Table>
    );
  }
}

@withRouter
export default class Datatablesjs extends React.Component {
  render() {
    return (
        <Row>
          <Col xs={12}>
            <PanelContainer controls={false}>
              <Panel>
                <PanelHeader className="bg-pinkishred fg-white">
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        <h3>
                          <Icon glyph="icon-fontello-users-1" />
                          &nbsp; Admin List
                        </h3>
                      </Col>
                    </Row>
                  </Grid>
                </PanelHeader>
                <PanelBody>
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        {
                          this.props.data.length > 0 ? (
                              <AdminUserTable data={this.props.data} />
                          ) : null
                        }
                        <br />
                      </Col>
                    </Row>
                  </Grid>
                </PanelBody>
              </Panel>
            </PanelContainer>
          </Col>
        </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/admin/Datatablesjs.js